import React from 'react';

// eslint-disable-next-line jsx-a11y/anchor-has-content
const NativeLink: React.StatelessComponent<any> = ({ to, ...props }) => <a href={to} {...props} />;

export default NativeLink;
